
import { useEffect } from 'react';
import { EmailDetailContent } from './components/EmailDetailContent';
import { EmailDetailSkeleton } from './components/EmailDetailSkeleton';
import { EmailDetailError } from './components/EmailDetailError';
import { useEmailDetailLogic } from './hooks/useEmailDetailLogic';
import EmailComposeOverlay from '@/components/email/layout/EmailComposeOverlay';
import { setDynamicPageTitle } from '@/components/layout/utils/dynamicPageTitle';

const EmailDetailView = () => {
  const {
    email,
    loadingEmail,
    emailNotFound,
    showCompose,
    composeType,
    folder,
    loading,
    error,
    setShowCompose,
    setComposeType,
    handleBack
  } = useEmailDetailLogic();

  // Show the email subject in the top navbar instead of the raw email ID.
  useEffect(() => {
    if (email) {
      setDynamicPageTitle(email.subject?.trim() || '(No Subject)');
    }
    return () => setDynamicPageTitle(null);
  }, [email?.id, email?.subject]);

  // Show error state if database failed to load
  if (error) {
    return (
      <EmailDetailError 
        folder={folder} 
        type="database" 
        onBack={handleBack} 
      />
    );
  }

  // Show skeleton loading state while email is being fetched
  if (loadingEmail || loading) {
    return <EmailDetailSkeleton folder={folder} />;
  }

  // Show not found state only after we've confirmed the email doesn't exist
  if (emailNotFound || !email) {
    return (
      <EmailDetailError 
        folder={folder} 
        type="not-found" 
        onBack={handleBack} 
      />
    );
  }

  const handleComposeClose = () => {
    setShowCompose(false);
    setComposeType(null);
  };

  const handleComposeSent = () => {
    setShowCompose(false);
    setComposeType(null);
  };

  return (
    <div className="flex flex-col h-full">
      <EmailDetailContent
        email={email}
        showCompose={showCompose}
        composeType={composeType}
        onShowCompose={setShowCompose}
        onSetComposeType={setComposeType}
        onBack={handleBack}
      />
      
      <EmailComposeOverlay
        showCompose={showCompose}
        onClose={handleComposeClose}
        onSent={handleComposeSent}
        initialEmail={email}
        isReply={composeType === 'reply' || composeType === 'reply-all'}
        isReplyAll={composeType === 'reply-all'}
        isForward={composeType === 'forward'}
      />
    </div>
  );
};

export default EmailDetailView;
